/**
 * Dynamically load the Google reCAPTCHA v2 script.
 * Used as a fallback in case the <script> tag in index.html was blocked or not loaded yet.
 */

const RECAPTCHA_SCRIPT_URL = 'https://www.google.com/recaptcha/api.js';

let loaded = false;
let loading = false;

export function loadRecaptchaScript(): Promise<void> {
  if (loaded) return Promise.resolve();
  if (typeof document === 'undefined') return Promise.resolve();

  const existing = document.querySelector(`script[src*="recaptcha/api.js"]`);
  if (existing) {
    loaded = true;
    return Promise.resolve();
  }

  if (loading) {
    return new Promise((resolve) => {
      const check = () => {
        if (loaded) resolve();
        else setTimeout(check, 50);
      };
      check();
    });
  }

  loading = true;
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = RECAPTCHA_SCRIPT_URL;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      loaded = true;
      loading = false;
      resolve();
    };
    script.onerror = () => {
      loading = false;
      resolve();
    };
    document.head.appendChild(script);
  });
}
